<template>
  <div class="grid-card-container">
    <div class="grid-card left-col" :style="getCardStyle(-120, -120)">
      <div class="card-content">
        <div>
          <div class="cardTitle">服务用户</div>
          <div class="cardSubTitle">交付累计使用用户数</div>
        </div>
        <ArrowChart ref="arrowChartRef"></ArrowChart>
        <div class="numberBox">
          <div class="num">500,000+</div>
          <div class="mini">位</div>
        </div>
      </div>
    </div>
    <div class="grid-card center-top" :style="getCardStyle(0, -60)">
      <div class="card-content">
        <div>
          <div class="cardTitle">合作服务商</div>
          <div class="cardSubTitle">全国合作经销商</div>
        </div>
        <div class="numberBox">
          <div class="num">100+</div>
          <div class="mini">位</div>
        </div>
      </div>
    </div>
    <div class="grid-card center-bottom" :style="getCardStyle(0, -30)">
      <div class="card-content">
        <div>
          <div class="cardTitle">交付客户数</div>
          <div class="cardSubTitle">全国累计交付客户</div>
        </div>
        <div class="numberBox">
          <div class="num">200+</div>
          <div class="mini">位</div>
        </div>
      </div>
    </div>
    <div class="grid-card right-col" :style="getCardStyle(120, -120)">
      <div class="card-content">
        <div>
          <div class="cardTitle">设备生产交付</div>
          <div class="cardSubTitle">YAOKE已交付物联设备数</div>
        </div>
        <LineChart ref="lineChartRef"></LineChart>
        <div class="numberBox">
          <div class="num">5300+</div>
          <div class="mini">台</div>
        </div>
      </div>
    </div>
    <div class="grid-card bottom-1" :style="getCardStyle(-120, 120)">
      <div class="card-content">
        <div>
          <div class="cardTitle">累计捐赠</div>
        </div>
        <div class="numberBox">
          <div class="num">200万+</div>
        </div>
      </div>
    </div>
    <div class="grid-card bottom-2" :style="getCardStyle(0, 120)">
      <div class="card-content">
        <div>
          <div class="cardTitle">产品荣誉</div>
        </div>
        <div class="numberBox">
          <div class="num">100+</div>
        </div>
      </div>
    </div>
    <div class="grid-card bottom-3" :style="getCardStyle(120, 120)">
      <div class="card-content">
        <div>
          <div class="cardTitle">公司运营</div>
        </div>
        <div class="numberBox">
          <div class="mini">覆盖</div>
          <div class="num">20+</div>
          <div class="mini">省</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineExpose  } from "vue";
import LineChart from "@/views/home/components/lineChart.vue";
import ArrowChart from "@/views/home/components/arrowChart.vue";
import { useTransition } from '@vueuse/core'

const props = defineProps({
  animationDuration: {
    type: Number,
    default: 600,
  },
  staggerDelay: {
    type: Number,
    default: 100,
  },
});
const isCombined = ref(false);
const lineChartRef = ref(null)
const arrowChartRef = ref(null)

const getCardStyle = (x, y) => {
  const index = Math.random() * 5;
  if (!isCombined.value) {
    return {
      transform: `translate(${x}px, ${y}px) scale(0.8)`,
      opacity: 0,
      transition: `all ${props.animationDuration}ms ease-out ${
        index * props.staggerDelay
      }ms`,
    };
  } else {
    // 组合状态 - 回到网格位置
    return {
      transform: "translate(0, 0) scale(1)",
      opacity: 1,
      transition: `all ${props.animationDuration}ms ease-out ${
        index * props.staggerDelay
      }ms`,
    };
  }
};

//动画效果
const animate = ()=>{
  isCombined.value = true;
  lineChartRef.value?.animate()
  arrowChartRef.value?.animate()
}

defineExpose({
  animate
})
</script>

<style scoped>
.grid-card-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 10.625rem 1fr 1fr 1fr 1fr;
  grid-template-areas:
    "left left left left center-top right right right right"
    "left left left left center-bottom right right right right"
    "bottom1 bottom1 bottom1 bottom2 bottom2 bottom2 bottom3 bottom3 bottom3";
  grid-gap: 20px;
  width: 100%;
  min-height: 500px;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}

.grid-card {
  background: #fff;
  border-radius: 1rem;
  cursor: pointer;
  will-change: transform, opacity;
  box-shadow: 0px 0px 30px #0000001a;
}

/* 卡片位置定义 */
.left-col {
  grid-area: left;
}

.center-top {
  grid-area: center-top;
}

.center-bottom {
  grid-area: center-bottom;
}

.right-col {
  grid-area: right;
}

.bottom-1 {
  grid-area: bottom1;
}

.bottom-2 {
  grid-area: bottom2;
}

.bottom-3 {
  grid-area: bottom3;
}

.card-content {
  width: 100%;
  height: 100%;
  padding: 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* 悬停效果 */
.grid-card:hover {
  transform: translateY(-5px) scale(1.05);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 10;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .grid-card-container {
    grid-template-columns: 1fr;
    grid-template-areas:
      "left"
      "center-top"
      "center-bottom"
      "right"
      "bottom1"
      "bottom2"
      "bottom3";
    grid-template-rows: auto;
  }

  .left-col,
  .right-col {
    height: auto;
  }
}

.cardTitle {
  color: #212121;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin-bottom: 0.5rem;
}

.cardSubTitle {
  color: #888888;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.375rem;
}

.numberBox {
  display: flex;
  align-items: flex-end;
}

.numberBox .mini{
  color: #888888;
  font-weight: 500;
  font-size: 0.875rem;
  margin-bottom: 6px;
}

.numberBox .num{
  color: #424242;
  font-weight: 600;
  font-size: 2rem;
}
</style>
